meedy.controller('meedy.opinionAddController', ['$rootScope','$scope', '$state', '$stateParams', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.opinionModel', '$timeout',
  function ($rootScope, $scope, $state, $stateParams, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, opinionModel, $timeout) {

    function setData() {
      $scope.currentUser = userModel.currentUser;
      $scope.opinion = new OpinionVO();
      $scope.disableSave = true;
      $scope.forms = {
        opinionForm: null
      }
    }
    function setPermissions() {
    }

    function setListeners() {
      $scope.$on('$destroy', function (event) {
        applicationModel.viewReady = false;
      });
    }

    function setActions() {

      $scope.save = function () {

        $scope.forms.opinionForm.$setSubmitted();
        $scope.formChanged($scope.forms.opinionForm);

        if ($scope.forms.opinionForm.$valid ) {
          opinionModel.save($scope.opinion);
          var successChange = $scope.$on(Event.MEEDY.OPINION.SAVE.SUCCESS, function (event, value) {
            successChange();
            errorChange();
            $state.go(Constant.STATE.APP.MEEDY.OPINION.CONFIRMED);
          });

          var errorChange = $scope.$on(Event.MEEDY.OPINION.SAVE.ERROR, function (event, value) {
            successChange();
            errorChange();

            $mdDialog.show({
              templateUrl: 'meedy/application/view/app/popup/popup-error.html',
              controller: 'popupErrorController',
              resolve: {
                error: function () {
                  return {
                    additionalMessage: 'T.MEEDY.SYSTEM.MESSAGE.OPINION.SAVE_ERROR',
                    message: 'T.SYSTEM.ERROR.ERROR'
                  };
                }
              }
            });
          });

        } else {
          console.log('dialog');
          $mdDialog.show({
            templateUrl: 'meedy/application/view/app/popup/popup-error.html',
            controller: 'popupErrorController',
            resolve: {
              error: function () {
                return {
                  additionalMessage: 'T.MEEDY.SYSTEM.MESSAGE.OPINION.FORM_INVALID',
                  message: 'T.MEEDY.SYSTEM.MESSAGE.OPINION.FORM_INVALID_TITLE'
                };
              }
            }
          });
        }
      };

      $scope.formChanged = function (form) {
        var mFLen = 0;
        var sILen = 0;
        var aFLen = 0;

        if ($scope.opinion.missingFeatures) mFLen = $scope.opinion.missingFeatures.length;
        if ($scope.opinion.suggestedImprovements) sILen = $scope.opinion.suggestedImprovements.length;
        if ($scope.opinion.appreciatedFeatures) aFLen = $scope.opinion.appreciatedFeatures.length;

        var valid = (mFLen > 0) || (sILen > 0) || (aFLen > 0);
        form.$setValidity('oneNotEmpty', valid);
      };

    }

    function configureInterface() {
      var breadcrumbItems = [];
      applicationModel.setBreadcrumbItems(breadcrumbItems);
      applicationModel.setTitleBar('T.MEEDY.MODULE.TITLE.OPINION.OPINION');
    }

    function initialize() {
      applicationModel.viewReady = true;
    }

    setData();
    setPermissions();
    setListeners();
    setActions();
    configureInterface();
    initialize();

  }
]);